import Alpine from 'alpinejs';
import axios from '../config/axios.js';

/**
 * Map pathname → page key (harus selaras dengan config/treasure_hunt.php).
 * Urutan: spesific dulu, baru generic (dashboard).
 */
export function resolveTreasurePageKey(pathname = window.location.pathname) {
  let path = pathname || '/';
  if (!path.startsWith('/')) path = `/${path}`;
  if (path.length > 1) path = path.replace(/\/+$/, '') || '/';

  const rules = [
    { key: 'wishlist', test: (p) => p === '/dashboard/wishlist' || p.startsWith('/dashboard/wishlist/') || p === '/wishlist' },
    { key: 'poin', test: (p) => p === '/dashboard/poin' || p.startsWith('/dashboard/poin/') || p === '/poin' },
    { key: 'surang', test: (p) => p === '/surang' || p.startsWith('/surang/') || p === '/surang-marketplace' || p.startsWith('/surang-marketplace') || p === '/surang-creator' || p.startsWith('/surang-creator') },
    { key: 'shop', test: (p) => p === '/shop' || p.startsWith('/shop/') },
    { key: 'framio', test: (p) => p === '/framio' || p.startsWith('/framio/') || p === '/twibbon' || p.startsWith('/twibbon/') },
    { key: 'flowers', test: (p) => p === '/flowers' || p.startsWith('/flowers/') || p === '/flower' || p.startsWith('/flower/') },
    { key: 'dashboard', test: (p) => p === '/dashboard' || (p.startsWith('/dashboard/') && !p.startsWith('/dashboard/poin') && !p.startsWith('/dashboard/wishlist')) },
    { key: 'login', test: (p) => p === '/login' },
    { key: 'register', test: (p) => p === '/register' },
    { key: 'home', test: (p) => p === '/' },
  ];

  for (const rule of rules) {
    if (rule.test(path)) return rule.key;
  }

  return null;
}

function createTreasureHunt() {
  return {
    ready: false,
    available: false,
    claimed: false,
    found: false,
    onThisPage: false,
    pageKey: null,
    pos: { left: 50, top: 40 },
    modal: false,
    claiming: false,
    reward: null,
    message: '',
    hintShown: false,

    /** Ikon HANYA di halaman host hari ini (sebelum ditemukan). */
    get showIcon() {
      return (
        this.ready &&
        this.available &&
        !this.claimed &&
        !this.found &&
        this.onThisPage === true &&
        !!this.pageKey &&
        !!Alpine.store('auth')?.isLoggedIn
      );
    },

    // backward-compat untuk template
    get visible() {
      return this.showIcon;
    },

    async init() {
      this.syncPageKey();
      if (!Alpine.store('auth')?.isLoggedIn) {
        this.ready = true;
        this.onThisPage = false;
        this.available = false;
        return;
      }
      await this.refresh();
      this.ready = true;

      window.addEventListener('popstate', () => {
        this.syncPageKey();
        this.refresh();
      });
    },

    syncPageKey() {
      this.pageKey = resolveTreasurePageKey(window.location.pathname);
    },

    async refresh() {
      this.syncPageKey();
      try {
        // Path adalah sumber kebenaran — jangan andalkan page saja
        const { data } = await axios.get('/api/v1/treasure-hunt/today', {
          params: {
            path: window.location.pathname,
            page: this.pageKey || undefined,
          },
        });
        const d = data.data || {};
        this.available = !!d.available;
        this.claimed = !!d.claimed;
        this.found = !!d.found;
        this.onThisPage = !!d.on_this_page;
        this.reward = d.reward || null;
        this.message = d.message || '';

        if (d.position && this.onThisPage && !this.found) {
          this.pos = { left: d.position.left, top: d.position.top };
        }

        // Modal klaim boleh di halaman mana pun setelah ditemukan
        if (this.found && !this.claimed) {
          this.modal = true;
        }

        if (this.available && !this.claimed && !this.onThisPage && !this.found && !this.hintShown) {
          this.hintShown = true;
          try {
            if (!sessionStorage.getItem('th_hint_shown')) {
              sessionStorage.setItem('th_hint_shown', '1');
              window.toast?.(this.message || 'INKO bersembunyi di halaman lain hari ini. Jelajahi USPATIH!', 'info');
            }
          } catch (_) {
            /* ignore */
          }
        }
      } catch (e) {
        this.available = false;
        this.onThisPage = false;
      }
    },

    async onFind() {
      if (!this.showIcon || this.claiming) return;
      this.claiming = true;
      try {
        const { data } = await axios.post('/api/v1/treasure-hunt/found', {
          path: window.location.pathname,
          page: this.pageKey,
        });
        this.found = true;
        this.onThisPage = true;
        this.message = data.message || data.data?.message || 'Kamu menemukan INKO!';
        this.modal = true;
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menandai temuan.', 'error');
      } finally {
        this.claiming = false;
      }
    },

    async claim() {
      if (this.claiming || this.claimed) return;
      this.claiming = true;
      try {
        const { data } = await axios.post('/api/v1/treasure-hunt/claim');
        const d = data.data || {};
        this.claimed = true;
        this.available = false;
        this.onThisPage = false;
        this.reward = d.reward || null;
        this.message = data.message || d.message || 'Hadiah diklaim!';
        window.toast?.(this.message, 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal klaim hadiah.', 'error');
      } finally {
        this.claiming = false;
      }
    },

    closeModal() {
      this.modal = false;
    },
  };
}

Alpine.data('treasureHunt', createTreasureHunt);
